import { $t } from '@/i18n';
import {
  XyPageletPropsEditorMeta,
} from '../paramsFormComponents';
import { CATEGORY } from './const';
import logger from '@utils/logger';

export default [
  {
    id: 'pagelet:emitEvent',
    name: $t('k_ece20544'),
    desc: $t('k_4fd51ad'),
    category: CATEGORY.LOGIC,
    paramsSchema: {
      type: 'object',
      fields: [
        {
          id: 'eventName',
          title: $t('k_46887ac9'),
          type: 'string',
          enum: [
            { label: $t('k_839a3e2f'), value: '' },
            { label: $t('k_a6129a05'), value: 'presetEventA' },
            { label: $t('k_e5868a4d'), value: 'presetEventB' },
            { label: $t('k_81dc7095'), value: 'presetEventC' },
            { label: $t('k_7a3fc12a'), value: 'presetEventD' },
            { label: $t('k_8d6b2f84'), value: 'presetEventE' },
          ],
          default: '',
        },
        {
          id: 'data',
          type: 'array',
          title: $t('k_35a1ec73'),
          'uc:allowInterop': true,
          ui: {
            type: 'XyPageletPropsEditor',
            props: {
              getPagelet: () => null,
            },
          },
          items: {
            type: 'object',
            fields: [
              { id: 'key', type: 'string' },
              { id: 'value', type: 'string' },
            ],
          },
        },
      ],
    },
    paramsFormComponents: [
      XyPageletPropsEditorMeta,
    ],
    execute: async (ctx, params) => {
      const { wContext } = ctx.renderer;  // xy 上下文
      const { eventName, data } = params;

      if (!eventName) {
        const msg = $t('k_2314c3dd');
        logger.info(msg);
        throw new Error(msg);
      }

      const kv = {};
      if (Array.isArray(data)) {
        data.forEach((item) => {
          const { key, value } = item;
          kv[key] = value;
        });
      }

      wContext?.container?.$emit(eventName, kv);
    },
  },
];
